<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="content-box">
    <div class="tarbar-box">
      <van-tabs v-model="activeName" @click="onClick">
        <van-tab title="未完成" name="undo"></van-tab>
        <van-tab title="全部" name="all"></van-tab>
      </van-tabs>
    </div>


    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <order-item :list="list"></order-item>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
  <van-action-sheet v-model="actionShow" :actions="actions" cancel-text="取消" close-on-click-action @select="onSelect" />
</div>
</template>

<script>
import api from '@/fetch/api'
import Nav from "../Public/navTpl.vue"
import OrderItem from "./OrderItem.vue"
import {
  Toast,
} from 'vant';

export default {
  components: {
    Nav,OrderItem
  },
  methods: {
    onClick() {
      //onClick(name, title)
      this.$data.list = [];
      this.onRefresh();
    },
    getNowOrderList() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      that.$data.activeName = 'undo';
      setTimeout(() => {
        that.refreshing = false;
        api.getNowOrderList(openid).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            //var dataList = res.data;
            that.$data.list = res.data;

            that.$data.loading = false;
            if (that.$data.list.length < 10) {
              that.$data.finished = true;
            }

          }
        }).catch(function(err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        });
      }, 1000);
    },
    getOrderList() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      that.$data.activeName = 'all';
      var page = that.$data.page;
      api.getOrderList(openid, page).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          that.$data.list = res.data;

          that.$data.loading = false;
          if (that.$data.list.length < 10) {
            that.$data.finished = true;
          }
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    onLoad() {
      var activeName = this.$data.activeName;
      this.$data.page = this.$data.page + 1;
      if (activeName == 'undo') {
        this.getNowOrderList();
      } else {
        this.getOrderList();
      }
    },
    onRefresh() {
      // 清空列表数据
      this.$data.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.$data.loading = true;
      this.$data.page = 0;
      this.onLoad();
    },
    chooseActions(id, sfscdzyd) {
      var that = this;
      that.$data.actionId = id;
      that.$data.sfscdzyd = sfscdzyd;
      if (sfscdzyd === "1") {
        that.$data.actions = [{
          name: '订单详情'
        }, {
          name: '上传电子运单'
        }];
      } else {
        that.$data.actions = [{
          name: '订单详情'
        }];
      }
      this.actionShow = true;
    },
    onSelect(item) {
      var that = this;
      var actionId = that.$data.actionId;
      if (actionId) {
        if (item.name == '订单详情') {
          that.$router.push({
            name: 'orderdetail',
            params: {
              id: actionId
            }
          })
        } else if (item.name == '上传电子运单') {
          that.$router.push({
            name: 'uploadth',
            params: {
              id: actionId
            }
          })
        }
      } else {
        Toast('网络异常');
      }
    }

  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      activeName: 'undo',
      page: 0,
      sheetshow: false,
      actionShow: false,
      actionId: 0,
      actions: [{
        name: '订单详情'
      }, {
        name: '上传电子运单'
      }],
    }
  },
}
</script>

<style lang="scss" scoped>

.content-box {
    margin-top: 3.75rem;
}

</style>
